import { render, staticRenderFns } from "./WhatDoesItMean.vue?vue&type=template&id=2c8d38fc&scoped=true"
import script from "./WhatDoesItMean.vue?vue&type=script&lang=js"
export * from "./WhatDoesItMean.vue?vue&type=script&lang=js"
import style0 from "./WhatDoesItMean.vue?vue&type=style&index=0&id=2c8d38fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d38fc",
  null
  
)

export default component.exports